import controller from "emun.cart/cart-picker.controller";
import templateUrl from "emun.cart/cart-picker.htm";
import modals from "webmodals/modals";

export default ($cart, $q, $rootScope) =>
  class CartPicker {
    constructor(options) {
      if (!options) options = {};
      let picker = this;
      ["selecting", "selected"].forEach((k) => {
        picker[k] = $q.defer();
        picker[k].on =
          picker[k].subscribe =
          picker[k].sub =
            (cb) => picker[k].promise.finally(null, cb);
      });
    }
    open(current) {
      let picker = this;
      if (!current) current = $cart;
      let modalInstance = (picker.modal = modals.open({
        size: "md",
        templateUrl,
        controller,
        bindToController: true,
        controllerAs: "$ctrl",
        resolve: {
          options: () => {
            return { title: "Please make a selection below...", current };
          },
        },
      }));

      modalInstance.result.then((cart) => {
        picker.selected.notify(cart);
        $rootScope.$emit("cartSelected", cart);
      });
      return modalInstance.result;
    }
  };
